module.exports = __webpack_public_path__ + "img/rsz_e-factoring-1.73234096.jpg";